import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=0136ca76&scoped=true&"
import script from "./ChannelItem.ts?vue&type=script&lang=ts&"
export * from "./ChannelItem.ts?vue&type=script&lang=ts&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&id=0136ca76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136ca76",
  null
  
)

export default component.exports